import type { ChangeEvent, FormEvent } from 'react';
import { appCopy } from '@zibanu/shared';
import { Banner, Button, TextField } from '@zibanu/ui';

/** The number field's id: the takeover finds it to give focus back (issue #8). */
export const LOGIN_NUMBER_ID = 'login-number';

export interface LoginFormProps {
  /** Drawn at build time into login.html: the button stays off until the app takes over (issue #8). */
  predrawn?: boolean;
  value: string;
  onChange?: (value: string) => void;
  onSubmit?: () => void;
  error?: string | undefined;
  busy?: boolean;
  /** "Please log in again": a session on this phone ended. */
  ended?: boolean;
}

/** "Open your books" as markup only (spec 3A §7.9): the live screen and the pre-drawn login.html both draw it. */
export function LoginForm({ predrawn = false, value, onChange, onSubmit, error, busy = false, ended = false }: LoginFormProps) {
  const submit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit?.();
  };
  // Pre-drawn, the field belongs to the browser until the app takes over; live, to React.
  const field = predrawn
    ? { defaultValue: value }
    : { value, onChange: (e: ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value) };
  return (
    <main className="zw-login">
      <div className="zw-word">{appCopy.wordmark()}</div>
      <h1 className="zw-h1">{appCopy.loginTitle()}</h1>
      {ended && <Banner tone="info" title={appCopy.logInAgain()} />}
      <p className="zw-lead">{appCopy.loginLead()}</p>
      <form className="zw-login__form" onSubmit={submit} noValidate data-predrawn={predrawn ? '' : undefined}>
        <TextField
          id={LOGIN_NUMBER_ID}
          label={appCopy.loginNumberLabel()}
          prefix="+234"
          inputMode="tel"
          autoComplete="tel-national"
          {...field}
          error={error}
        />
        <div className="zw-push">
          <Button type="submit" size="lg" block disabled={predrawn || busy}>
            {appCopy.loginSendCode()}
          </Button>
          <p className="zw-muted">{appCopy.loginChatHint()}</p>
        </div>
      </form>
    </main>
  );
}
